<template>
  <div>
    <!-- <div 
      class="ui primary button" 
      style="background-color: #092442; margin-bottom: 10px"
      @click="showModal()"
      v-if="!cancelled && $auth.user().can_make_transaction && !settings[1].value && canAddTransaction">
      {{ $t('addTransaction') }}
    </div> -->
    <div v-if="(transactions && transactions.length > 0) || packages.length">
      <abstractTable 
        :columns="transactionColumns" 
        :data="computedTransactions()"
        :classes="'ui very compact center aligned celled table'"
        v-if="!settings[1].value"
      />
      
      <div v-if="packages.length">
        <h4 class="ui horizontal divider header"> Uncomplete package transactions</h4>
        <abstractTable 
          :columns="packageRemainderTransactionsColumns" 
          :data="computedPackageRemainders()"
          :classes="'ui very compact center aligned celled table'"
        >
          <template slot="table-column">
            <th class="no-print"> {{ $t('actions') }} </th>
          </template>
          <template slot="table-row-after" slot-scope="props">
            <td class="no-print">
              <div 
                class="ui blue tiny button"
                style="background-color: #092442"
                @click="showModal(props.row.id)"
                v-if="props.row.remainderNumber > 0"
              >
                Add transaction
              </div>
            </td>
          </template>
        </abstractTable>
      </div>
    </div>

    <div class="ui placeholder segment" v-else>
      <div class="ui icon header" style="color: #092442">
        <i class="dont icon"></i>
        {{ $t('noTransactionsHaveBeenAddedYet') }}
      </div>
      <div class="ui primary button" style="background-color: #092442"
           @click="showModal()"
           v-if="!cancelled && $auth.user().can_make_transaction">
        {{ $t('addTransaction') }}
      </div>
    </div>

    <div class="ui large longer modal" id="transaction" style="margin-top: 20px !important;">
      <div class="header">{{ $t('addTransaction') }}</div>
      <div class="scrolling content">
        <div class="ui form">
          <div class="two required fields">
            <div class="field">
              <label for="transactionAmount">{{ $t('transactionAmount') }}</label>
              <div class="ui input left icon">
                <i class="money icon"></i>
                <input 
                  type="number" 
                  :placeholder="$t('transactionAmount')" 
                  v-model="transactionParams.amount"
                  name="transactionAmount"
                />
              </div>
            </div>
          </div>

          <div class="ui toggle checkbox">
            <input type="checkbox" v-model="transactionParams.online" />
            <label>Online</label>
          </div>

          <div class="field">
            <label for="description">{{ $t('description') }}</label>
            <textarea 
              :placeholder="$t('transactionAmount')" 
              v-model="transactionParams.description"
              name="description"
            />
          </div>

          <div class="ui blue right floated button"
               style="background-color: #092442"
               @click="save()">
            {{ $t('save') }}
          </div>

          <div class="ui right floated button"
               @click="hideModal()">
            {{ $t('discard') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    transactions: { type: Array, default: () => { return [] } },
    reservationTransactions: { type: Array, default: () => { return [] } },
    reservationId: { type: Number, required: true },
    cancelled: { type: String, default: null },
    clinicId: { type: Number, required: true },
    packages: { type: Array, required: true }
  },
  data () {
    return {
      transactionParams: {
        amount: null,
        description: null,
        online: false,
        package_id: null
      }
    }
  },
  mounted () {
  },
  computed: {
    transactionColumns () {
      return [
        { header: 'Package', fieldName: 'packageName', show: true },
        { header: 'Cash', fieldName: 'cash', show: true, width: '12%' },
        { header: 'Visa', fieldName: 'visa', show: true, width: '12%' },
        { header: 'Credit', fieldName: 'credit', show: true, width: '12%' },
        { header: 'debit', fieldName: 'debit', show: true, width: '12%' },
        { header: this.$t('description'), fieldName: 'description', show: true },
        { header: this.$t('paidAt'), fieldName: 'paid_at', show: true }
      ]
    },
    packageRemainderTransactionsColumns () {
      return [
        { header: 'Package', fieldName: 'name', show: true },
        { header: 'Remainder Money', fieldName: 'remainder', show: true, html: true },
      ]
    },
    currentDate () {
      return window.moment().format('LLLL')
    },
    canAddTransaction () {
      return !this.reservationTransactions || !this.reservationTransactions.length || 
      (this.reservationTransactions && this.reservationTransactions.length &&
        this.reservationTransactions[this.reservationTransactions.length - 1].debit > 0)
    }
  },
  methods: {
    computedTransactions () {
      let formlatedTransactions = []
      const reservationTransactionsByTransactionId =
        this.reservationTransactions.reduce((obj, rt) => ({...obj, [rt.transaction_id]: rt}), {})
      const packagesById = this.packages.reduce((obj, p) => ({...obj, [p.id]: p}), {})
      window._.each(this.transactions, transaction => {
        const p = packagesById[reservationTransactionsByTransactionId[transaction.id].package_id]
        formlatedTransactions.push({
          id: transaction.id,
          packageName: p.name, 
          cash: transaction.online ? '-' : this.formatPrice(transaction.amount),
          visa: transaction.online ? this.formatPrice(transaction.amount) : '-',
          credit: this.formatPrice(reservationTransactionsByTransactionId[transaction.id].credit),
          debit: this.formatPrice(reservationTransactionsByTransactionId[transaction.id].debit),
          description: transaction.description || '-',
          paid_at: window.moment(transaction.paid_at).format('DD/MM/YYYY HH:mm')
        })
      })

      return formlatedTransactions
    },
    computedPackageRemainders () {
      return this.packages.map(p => ({
        id: p.id,
        name: p.name,
        remainderNumber: p.remainder,
        remainder: {
          value: `<p style="color: ${p.remainder > 0 ? 'red' : 'black'};">${this.formatPrice(p.remainder)}</p>`,
          filteredValue: p.remainder
        }
      }))
    },
    showModal (packageId) {
      this.transactionParams.package_id = packageId
      $('#transaction').modal('show').modal('refresh')
      this.initGui()
    },
    hideModal () {
      this.transactionParams = {
        amount: null,
        description: null,
        package_id: null,
        paid_at: window.moment()
      }

      $('#transaction').modal('hide')
    },
    initGui () {
      this.$nextTick(() => {
        $('#reservation-transaction-paid-at').calendar({
          type: 'datetime',
          onChange: (date) => {
            this.transactionParams.paid_at = date
          },
          isDisabled: (date, mode) => {
            return false
          }
        })

        $('#transaction').form({
          inline: true,
          on: 'blur',
          fields: {
            transactionAmount: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter the transaction amount.'
                },
                {
                  type: 'number',
                  prompt: 'Please enter a valid number.'
                }
              ]
            },
            paidAt: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Choose reservation date.'
                }
              ]
            },
            description: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Write description for this transaction.'
                }
              ]
            }
          }
        })
      })
    },
    save () {
      const transaction = {
        clinic_id: this.getFromLocalStorage('clinicId'),
        reservation_id: this.reservationId,
        transactions: [this.transactionParams]
      }

      this.$http.post('reservation_transactions', {
        ...transaction
      }).then(response => {
        this.transactions.push(response.data.transactions[0])
        this.reservationTransactions.push(response.data.meta.reservation_transactions[0])
        this.$emit('transaction-part-updated')
        this.hideModal()
      })
    }
  },
  beforeDestroy () {
    $('#transaction').remove();;
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/reservations/reservation_components/TransactionsPart.vue